import React, { useState, useEffect, useRef } from 'react';
import { Layer, Circle } from 'react-konva';

const MarkComponent = ({ markDetails, saveMark, stageScale }) => {
    const { x, y, step, show, rings } = markDetails;
    const [currentX, setCurrentX] = useState(x);
    const [currentY, setCurrentY] = useState(y);
    const circleRef = useRef(null);

    const MIN_SCALE = 0.5;
    const MAX_SCALE = 2;
    const inverseScale = 1 / Math.max(MIN_SCALE, Math.min(MAX_SCALE, stageScale));
    const adjustedScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, 1 / stageScale));

    useEffect(() => {
        setCurrentX(x);
        setCurrentY(y);
    }, [x, y]);

    const handleDragMove = (e) => {
        const generateRingPoints = (centerX, centerY, radius, numPoints = 36) => {
            const points = [];
            
            const pointsForCurrentRing = Math.min(Math.max(Math.floor(2 * Math.PI * radius / (2 * Math.PI / numPoints)), 36), 400);
            
            for (let i = 0; i < pointsForCurrentRing; i++) {
                const angle = (2 * Math.PI * i) / pointsForCurrentRing;
                const x = centerX + radius * Math.cos(angle);
                const y = centerY + radius * Math.sin(angle);
                points.push({ x, y });
            }
        
            return points;
        };
        
        const allPoints = [];
        for (let i = 0; i < rings; i++) {
            const radius = step * (i + 1) * inverseScale * 2;
            const ringPoints = generateRingPoints(newX, newY, radius);
            allPoints.push(...ringPoints);
        }
        allPoints.push({ x: x, y: y });
        

        const newX = e.target.x();
        const newY = e.target.y();
        setCurrentX(newX);
        setCurrentY(newY);

        const markData = {
            x: parseFloat(newX),
            y: parseFloat(newY),
            step: parseFloat(step),
            snap: markDetails.snap,
            show: markDetails.show,
            rings: parseInt(rings, 10),
            points: allPoints,
        };

        saveMark(markData);
    };

    return (
        <Layer>
            {show && (
                <>
                    {Array.from({ length: rings }).map((_, index) => {
                       const radius = step * (index + 1);
                        return (
                            <Circle
                                key={index}
                                x={currentX}
                                y={currentY}
                                radius={radius}
                                stroke="gray"
                                fill="transparent"
                                strokeWidth={Math.max(0.05, 0.8 / stageScale)}
                            />
                        );
                    })}

                    <Circle
                        ref={circleRef}
                        x={currentX}
                        y={currentY}
                        radius={Math.max(2.5 / 5 * adjustedScale)}
                        stroke="gray"
                        fill="gray"
                        strokeWidth={Math.max(1 / stageScale)}
                        draggable
                        onDragMove={handleDragMove}
                    />
                </>
            )}
        </Layer>
    );
};

export default MarkComponent;
